import React from 'react';
import FormField from './FormField';

const NotesField = ({rows, ...props}) => (

    <FormField
        id="standard-multiline-static"
        multiline
        rows={rows || 2}
        margin="normal"
        maxLength={2000}
        {...props}
    />
);

NotesField.defaultProps = {
    rows: 2,
};

export default NotesField;
